import Home from "./pages/home";
import About from "./pages/about";
import Gallery from "./pages/gallery";
import SupplyAndInstall from "./pages/services/supply-install";
import Carpet from "./pages/services/carpet";
import Vinyl from "./pages/services/vinyl";
import Tile from "./pages/services/tile";
import Timber from "./pages/services/timber";
import Contact from "./pages/contact";
import Blog from "./pages/blog";
import Quote from "./pages/quote";
import Navigation from "./components/navigation";
import Footer from "./components/footer";
import "./style.css";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <div>
        <Navigation />
        <Switch>
          <Route path="/services/supply-install">
            <SupplyAndInstall />
          </Route>
          <Route path="/services/carpet">
            <Carpet />
          </Route>
          <Route path="/services/vinyl">
            <Vinyl />
          </Route>
          <Route path="/services/tile">
            <Tile />
          </Route>
          <Route path="/services/timber">
            <Timber />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/gallery">
            <Gallery />
          </Route>
          <Route path="/blog">
            <Blog />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/quote">
            <Quote />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
